<!-- User Info Card - Shown when data is complete and not editing -->
@if (shouldShowInfo()) {
  <activar-card class="max-w-2xl mx-auto">
    <div class="space-y-4">
      <!-- Header -->
      <div class="flex items-center justify-between">
        <div>
          <h3 class="text-lg font-semibold text-gray-900">{{ displayName }}</h3>
          <p class="text-sm text-gray-600">{{ identificationLabel }}: {{ (user().identification || '') | mask: identificationMask }}</p>
        </div>
        <activar-button
          text="Editar"
          color="secondary"
          fill="out"
          size="sm"
          (click)="startEditing()"
        />
      </div>

      <!-- User Details -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t border-gray-100">
        <!-- Email -->
        <div>
          <span class="text-sm font-medium text-gray-700">Email</span>
          <p class="text-sm text-gray-900">{{ user().email }}</p>
        </div>

        <!-- Address -->
        <div>
          <span class="text-sm font-medium text-gray-700">Dirección</span>
          <p class="text-sm text-gray-900">{{ user().address }}</p>
        </div>

        <!-- Postal Code -->
        <div>
          <span class="text-sm font-medium text-gray-700">Código Postal</span>
          <p class="text-sm text-gray-900">{{ user().postalCode }}</p>
        </div>

        <!-- Company specific fields -->
        @if (user().type !== 'PERSON') {
          <div>
            <span class="text-sm font-medium text-gray-700">Condición ante Ingresos Brutos</span>
            <p class="text-sm text-gray-900">{{ user().grossIncomeCondition || 'No especificado' }}</p>
          </div>
        }

        <!-- Person specific fields -->
        @if (isUserType(user().type, USER_TYPES.PERSON)) {
          <div>
            <span class="text-sm font-medium text-gray-700">Fecha de Nacimiento</span>
            <p class="text-sm text-gray-900">{{ formatDate(user().birthDate) }}</p>
          </div>
        }
      </div>

      <!-- Continue Button -->
      <div class="flex justify-end pt-6 border-t border-gray-100">
        <activar-button
          text="Continuar"
          color="primary"
          fill="solid"
          (click)="onContinueWithoutUpdate()"
        />
      </div>
    </div>
  </activar-card>
}

<!-- User Update Form - Shown when data is incomplete or editing -->
@if (shouldShowForm()) {
  <div class="max-w-2xl mx-auto">
    @if (isEditing()) {
      <!-- Back button when editing -->
      <div class="mb-4 flex justify-start">
        <activar-back-button
          text="Volver"
          (click)="cancelEditing()"
        />
      </div>
    }
    
    <activar-card>
      <app-user-update-form 
        [user]="user()" 
        [loading]="loading()"
        (userUpdated)="onUserUpdated($event)" 
      />
    </activar-card>
  </div>
}